import { useMemo, type PropsWithChildren } from 'react';
import {
	TomAssistantSessionActionsContext,
	TomAssistantSessionContext,
} from '../context';
import { useTomChatController } from '../hooks/useTomChatController';

export const TomAssistantSessionHost = ({ children }: PropsWithChildren) => {
	const controller = useTomChatController();
	const state = useMemo(
		() => ({
			isBusy: controller.isBusy,
			canStop: controller.canStop,
			streamConversationId: controller.streamConversationId,
			activeAssistantMessageId: controller.activeAssistantMessageId,
			retryingMessageId: controller.retryingMessageId,
			progressLabel: controller.progressLabel,
			messageOverlays: controller.messageOverlays,
		}),
		[
			controller.activeAssistantMessageId,
			controller.canStop,
			controller.isBusy,
			controller.messageOverlays,
			controller.progressLabel,
			controller.retryingMessageId,
			controller.streamConversationId,
		],
	);
	const actions = useMemo(
		() => ({
			removeResolvedMessageOverlays:
				controller.removeResolvedMessageOverlays,
			clearConversationOverlays: controller.clearConversationOverlays,
			runStream: controller.runStream,
			stopResponse: controller.stopResponse,
			cancelResponseForSwitch: controller.cancelResponseForSwitch,
		}),
		[
			controller.cancelResponseForSwitch,
			controller.clearConversationOverlays,
			controller.removeResolvedMessageOverlays,
			controller.runStream,
			controller.stopResponse,
		],
	);

	return (
		<TomAssistantSessionActionsContext.Provider value={actions}>
			<TomAssistantSessionContext.Provider value={state}>
				{children}
			</TomAssistantSessionContext.Provider>
		</TomAssistantSessionActionsContext.Provider>
	);
};
